
















































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Action} from "vuex-class";
import {ProxySettingFilter} from "@/store/settings/proxy_settings/types";
import BaseFilter from "@/components/Filter/BaseFilter";
import {notifyError} from "@/utils/notify-helper";
import {InputWings} from "wings-ui-components";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {InputWings}})
export default class ProxySettingsFilter extends BaseFilter<ProxySettingFilter> {
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync('show') is_show!: boolean;

  @Action("getProxySettings") actionGetProxySettings: any;

  defaultFilter(): ProxySettingFilter {
    return {
      name: undefined,
      host: undefined,
      port: undefined,
      page_number: 1
    }
  }

  async created() {
    try {
      await this.filtered();
      this.actionGetProxySettings(this.filter);
      this.scroll();
    } catch (err) {
      notifyError(err);
    }
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: 'success',
        object_type: "Proxy-servers",
        addititional_info: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetProxySettings(this.filter);
      this.is_last = resp.length == 0;
      await this.actionLog(this.logObject);
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: ProxySettingFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
